export default __webpack_public_path__ + "static/media/iconLoungeChair.954a065d.svg";